(function () {
  var MID_RANGE_BADGE = '$20 off at Checkout (Code: BUYSC20) $249 min order or 0% Financing for 12 Months with Affirm';
  var HIGH_RANGE_BADGE = '$50 Off at Checkout (Code: PREPAY) $700 min order or 0% Financing for 12 Months with Affirm';

  var ICON_SVG =
    '<svg class="squarecable-product-badges__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="#48A311" aria-hidden="true" focusable="false">' +
    '<path d="M7.6 13.2L14.65 6.15L13.25 4.75L7.6 10.4L4.75 7.55L3.35 8.95L7.6 13.2ZM0 18V0H18V18H0ZM2 16H16V2H2V16Z"/>' +
    '</svg>';

  // Responsive CSS injected inline so the file works even if base.css is not
  // fully up to date. Rules use higher specificity / !important to win against
  // EComposer styles and any leftover rules in base.css.
  var INJECTED_CSS = [
    /* Container — force visibility across viewports in case EComposer hides
       the parent block via .ecom-hidden-* helper classes on some breakpoint. */
    '.ecom-block.ecom-jbv2ftxarzp {',
    '  display: block !important;',
    '  visibility: visible !important;',
    '  opacity: 1 !important;',
    '  margin-top: 0 !important;',
    '  padding-top: 0 !important;',
    '}',
    /* Desktop & tablet: horizontal flex wrap */
    '.squarecable-product-badges {',
    '  display: flex !important;',
    '  flex-wrap: wrap !important;',
    '  gap: 1rem 1.5rem !important;',
    '  align-items: center !important;',
    '  padding: 0 0 0.5rem !important;',
    '  margin-top: -0.5rem !important;',
    '  width: 100% !important;',
    '}',
    '.squarecable-product-badges__item {',
    '  display: inline-flex !important;',
    '  align-items: flex-start !important;',
    '  gap: 0.5rem !important;',
    '  font-size: 14px !important;',
    '  font-weight: 600 !important;',
    '  color: #000 !important;',
    '  line-height: 1.3 !important;',
    '  max-width: 100% !important;',
    '}',
    '.squarecable-product-badges__icon {',
    '  width: 18px !important;',
    '  height: 18px !important;',
    '  flex-shrink: 0 !important;',
    '  margin-top: 1px !important;',
    '}',
    /* Tablet (<=989px): smaller gap, allow wrap */
    '@media (max-width: 989px) {',
    '  .squarecable-product-badges { gap: 0.75rem 1rem !important; }',
    '  .squarecable-product-badges__item { font-size: 13.5px !important; }',
    '}',
    /* Mobile (<=749px): stack badges vertically (one per row) */
    '@media (max-width: 749px) {',
    '  .squarecable-product-badges {',
    '    flex-direction: column !important;',
    '    align-items: flex-start !important;',
    '    gap: 0.6rem !important;',
    '    margin-top: 0 !important;',
    '    padding: 0.5rem 0 !important;',
    '  }',
    '  .squarecable-product-badges__item {',
    '    width: 100% !important;',
    '    font-size: 13px !important;',
    '    line-height: 1.35 !important;',
    '  }',
    '  .squarecable-product-badges__icon {',
    '    width: 16px !important;',
    '    height: 16px !important;',
    '  }',
    '}'
  ].join('\n');

  function injectCSS() {
    if (document.getElementById('squarecable-product-badges-inline-css')) return;
    var style = document.createElement('style');
    style.id = 'squarecable-product-badges-inline-css';
    style.textContent = INJECTED_CSS;
    document.head.appendChild(style);
  }

  // Read the current product price from the page. Tries several strategies in
  // order of reliability. Returns a Number in dollars, or null if not found.
  function getProductPrice() {
    var jsonScripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < jsonScripts.length; i++) {
      var s = jsonScripts[i];
      if (!s.id || s.id.indexOf('product-json') < 0) continue;
      try {
        var data = JSON.parse(s.textContent);
        var raw = null;
        if (data.selected_or_first_available_variant && typeof data.selected_or_first_available_variant.price === 'number') {
          raw = data.selected_or_first_available_variant.price;
        } else if (data.variants && data.variants[0] && typeof data.variants[0].price === 'number') {
          raw = data.variants[0].price;
        } else if (typeof data.price === 'number') {
          raw = data.price;
        }
        if (raw !== null) return raw / 100;
      } catch (e) {}
    }

    var ldScripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (var j = 0; j < ldScripts.length; j++) {
      try {
        var ld = JSON.parse(ldScripts[j].textContent);
        var candidates = [].concat(ld);
        for (var k = 0; k < candidates.length; k++) {
          var c = candidates[k];
          if (c && c['@type'] === 'Product' && c.offers) {
            var offers = [].concat(c.offers);
            for (var m = 0; m < offers.length; m++) {
              if (offers[m].price !== undefined) {
                return parseFloat(offers[m].price);
              }
            }
          }
        }
      } catch (e) {}
    }

    var domEl = document.querySelector(
      '.ecom-product-single__price .money, ' +
      '.ecom-product-single__price, ' +
      '[data-product-price], ' +
      '.product__price'
    );
    if (domEl) {
      var match = domEl.textContent.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
      if (match) return parseFloat(match[1]);
    }

    return null;
  }

  // Returns the third badge text for the given price, or null if no third
  // badge should be shown (price outside the supported ranges, or unknown).
  function pickThirdBadge(price) {
    if (price === null || isNaN(price)) return null;
    if (price >= 249 && price <= 669) return MID_RANGE_BADGE;
    if (price >= 700) return HIGH_RANGE_BADGE;
    return null;
  }

  function buildBadgesList() {
    var list = [
      '90 Day Returns',
      '+1 Year Extended Warranty'
    ];
    var third = pickThirdBadge(getProductPrice());
    if (third !== null) list.push(third);
    return list;
  }

  function injectBadges() {
    var block = document.querySelector('.ecom-block.ecom-jbv2ftxarzp');
    if (!block) return false;
    if (block.querySelector('.squarecable-product-badges')) return true;

    var wrapper = document.createElement('div');
    wrapper.className = 'squarecable-product-badges';
    wrapper.setAttribute('role', 'list');

    wrapper.innerHTML = buildBadgesList().map(function (label) {
      return (
        '<div class="squarecable-product-badges__item" role="listitem">' +
          ICON_SVG +
          '<span>' + label + '</span>' +
        '</div>'
      );
    }).join('');

    block.appendChild(wrapper);
    return true;
  }

  function watchAndRetry() {
    // Permanent observer: if EComposer re-renders or hydrates the block later
    // (e.g. on a variant change or section reload), re-inject the badges.
    var observer = new MutationObserver(function () {
      injectBadges();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Safety net: retry every 300ms for up to 15 seconds in case the block
    // mounts after DOMContentLoaded on slow connections / certain viewports.
    var attempts = 0;
    var interval = setInterval(function () {
      if (injectBadges() || ++attempts >= 50) clearInterval(interval);
    }, 300);
  }

  function init() {
    injectCSS();
    injectBadges();
    watchAndRetry();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
